import styled from "styled-components";

const DivProfilePic = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    >img.profile-pic{
        border-radius: 50%;
        width: 108px;
        height: 108px;
        margin: 10px 0;
    }

    >h2{
        margin: 10px 0;
        color: var(--default-color-font);
    }

    >label{
        position: absolute;
        width: 38px;
        height: 38px;
        background: var(--purple-lighter);
        border-radius: 50%;
        right: 10%;
        bottom: 20%;
        border: 0;
        transition: 200ms;
        cursor: pointer;
        display:none;
        align-items:center;
        justify-content:center;

        >input{
            display: none;
        }

        >svg{
            width: 26px;
            height: 26px;
            color: var(--grey-soft);  
            &:hover{
                color: #FFF;
            }
        }
    }

    &:hover{
        >label{
            display: flex;
        }
    }
`;

export const FormStyled = styled.form`
    display: flex;
    flex-direction: column; 
    align-items: center; 
    width: 100%;
    max-width: 900px;
`;

export const StyledA = styled.a`
    color: var(--blue);
    font-size: 0.9rem;
    margin-left: 1rem;
    &:hover{
        text-decoration: underline;
    }
`;

export default DivProfilePic;

